'use client';

import React from 'react';
import { CircularProgress } from '@mui/material';
import { HeadlineSmall, BodyMedium, Center } from '../../styles';
import { BaseBackdrop } from '../backdrop';
import { useTheme } from '../../hooks';

type LoadingOverlayProps = {
    title: string;
    text: string;
};

const LoadingOverlay = ({ title, text }: LoadingOverlayProps) => {
    const { colors } = useTheme();

    return (
        <BaseBackdrop open={true}>
            <HeadlineSmall>{title}</HeadlineSmall>
            <BodyMedium sx={{ color: colors.onSurfaceVariant }}>{text}</BodyMedium>
            <Center>
                <CircularProgress
                    sx={{
                        color: colors.primary,
                        display: 'inline-block',
                        my: 2
                    }}
                    size={32}
                />
            </Center>
        </BaseBackdrop>
    );
};

export { LoadingOverlay };
